import React, { useState ,useEffect} from 'react';
import ReactStrapTable from 'components/reactStrapTable';
import { Button } from 'reactstrap';
import { cellRendererCheck, dateFormate } from 'utils/columns';
import AddModal from '../components/Add';
import EditIcon from 'assets/icon/icon-icon-options-edit.svg';
import EditIconHover from 'assets/icon/icon-icon-options-edit_hover.svg';
import HoverImage from 'react-hover-image/build';
import plus from "assets/icon/plus-icon.svg";
import EditModel from '../components/Edit';



let editFlag = false;
let addFlag = false;
const AdjustmentTable = ({
    rowData,
    tenantID,
    data,
    loading,
    onExport,
    filters,
    totalSize,
    onPageChange,
    refetch,
    setLoading,
    onSearchColumnFilters,
    reset,
    setHasToRest , 
}) => {
    const [addModal, updateAddModal] = useState(false);
    const [editModel , updateEditModal] = useState(false) ;
    const [editData, setEditData] = useState();
    const [addData, setAddData] = useState()

    const [state, updateState] = useState({
        tableData: [],
        backUpData: [],
        filters: filters,
    });
    useEffect(() => {
        setState({ tableData: data, backUpData: data });
    }, [data]);
    const setState = (obj) => updateState(pre => ({ ...pre, ...obj }));

    useEffect(() => {
        setState({ filters: filters });
    }, [filters]);

    const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
        if (hasColFilter) {
            setState({
                filters: filter,
            });
            let colFilterOn = { ...filter, filters: colChangedFilter };
            return onPageChange(colFilterOn, true);
        }
        setState({
            filters: filter,
        });
        onPageChange(filter);
    };

    const handleFilterCancel = () => {
        refetch(true);
    };
    const cellRenderEdit = (row) => {
        return (
            <div className='d-flex align-items-center'>
                <Button
                    className='text-primary p-0 text-decoration-none'
                    color='link'
                    onClick={() => onEditModal(row)}
                >
                    <HoverImage
                        key='EditIcon'
                        src={EditIcon}
                        hoverSrc={EditIconHover}
                        alt=''
                    />
                </Button>
            </div>
        )
    }
    let columns = [
        {
            dataField: 'options',
            text: 'Options',
            width: 100,
            short: false,
            show: true,
            hideColFilter: true,
            cellRenderer: (rowData) => cellRenderEdit(rowData),
            action: true
        },
        {
            dataField: 'ndc',
            text: 'NDC',
            sort: true,
            width: 140,
            show: true,
            inputType: 'text',
            cellRenderer: (rowData) => cellRendererCheck(rowData.ndc)
        },
        {
            dataField: 'drugDescription',
            text: 'NDC Description',
            sort: true,
            width: 140,
            show: true,
            inputType: 'text',
            cellRenderer: (rowData) => cellRendererCheck(rowData.drugDescription)
        },
        {
            dataField: 'packageSize',
            text: 'Package Size',
            sort: true,
            width: 140,
            show: true,
            inputType: 'number',
            cellRenderer: (rowData) => cellRendererCheck(rowData.packageSize)
        },
        {
            dataField: 'adjustmentDate',
            text: 'Adjustment Date',
            sort: true,
            width: 140,
            show: true,
            inputType: 'date',
            cellRenderer: (rowData) => dateFormate(rowData.adjustmentDate)
        },
        {
            dataField: 'packages',
            text: 'Packages',
            sort: true,
            width: 140,
            show: true,
            inputType: 'number',
            cellRenderer: (rowData) => cellRendererCheck(rowData.packages)
        },
        {
            dataField: 'comments',
            text: 'Comments',
            sort: true,
            width: 140,
            show: true,
            inputType: 'text',
            cellRenderer: (rowData) => cellRendererCheck(rowData.comments)
        },
        {
            dataField: 'userName',
            text: 'Users',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (rowData) => cellRendererCheck(rowData.userName)
        }
    ];
    const handleSearchColumnFilters = (colFilter) => {
        if (onSearchColumnFilters) {
            const filter = { ...state.filters, filters: colFilter, currentPage: 1 };
            onSearchColumnFilters(filter);
            setState({
                filters: filter,
            });
        }
    };

    const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
        if (hasColFilter) {
            setState({
                filters: filter,
            });
            let colFilterOn = { ...filter, filters: colChangedFilter };
            onPageChange(colFilterOn, true);
        } else {
            setState({
                filters: filter,
            });
            onPageChange(filter);
        }
    };

    const handleSort = (filter, hasColFilter) => {
        setState({
            filters: filter,
        });
        if (hasColFilter) {
            onPageChange(filter, true);
        } else {
            onPageChange(filter);
        }
    };

    const { filters: colFilter, backUpData } = state;

    const onToggleAddModal = () => {
        addFlag = false;
        setAddData();
        updateAddModal(!addModal);
        // onAddModal();
    };

    const onToggleEditModal = () => {
        editFlag = false;
        setEditData();
        updateEditModal(!editData);
    };




    // const onAddModal = (row) => {
    //     setAddData(row);
    //     addFlag = true;
    //     updateAddModal(!addModal);
    // };

      const onEditModal = (row) => {
        setEditData(row);
        editFlag = true;
        updateEditModal(!editModel);
    };


    return (
        <div
            className="table-card scroll-table position-relative border-0 rounded pt-0"
            fixed-height={data.length > 0 ? 'fixed-height' : 'default'}
        >
            <ReactStrapTable
                id='inventory-table'
                fixedColumn
                data={backUpData}
                loading={loading}
                columns={columns}
                hasScrollArrow={false}
                onPageSizeChange={onPageSizeChange}
                pageSize={colFilter.pageSize}
                onExport={onExport}
                hasPagination
                onPageChange={onHandlePageChange}
                currentPage={colFilter.currentPage}
                totalRecords={totalSize}
                handleSort={handleSort}
                filters={colFilter}
                onFilterCancel={handleFilterCancel}
                onSearchColumnFilters={handleSearchColumnFilters}
            >
                <Button onClick={onToggleAddModal} className='reset' color="primary" size="sm">
                    <span className="right_5">
                        <img src={plus} alt="" />
                    </span>{" "}
                    Add
                </Button>
                <div className="mx-4 d-inline-block text-light f-0 text-white font-weight-lighter border-end">|</div> {' '}
            </ReactStrapTable>
            <AddModal isOpen={addModal} refetch={refetch} rowData={rowData} packageSize={rowData.packageSize} editFlag={addFlag} addData={addData} tenantID={tenantID} toggle={onToggleAddModal}  setHasToRest= {setHasToRest}  />

            <EditModel isOpen={editModel} refetch={refetch} rowData={rowData} packageSize={rowData.packageSize} editFlag={editFlag} editData={editData} tenantID={tenantID} toggle={onToggleEditModal}  setHasToRest = {setHasToRest}  />

        </div>
    );
};

export default AdjustmentTable;
